import type { MarbleGame } from 'src/types/domain/Game'
import { useLayeredCrossfade } from 'src/hooks/useLayeredCrossfade'
import { TrackHighlightCard } from './components/TrackHighlightCard'

type Props = Readonly<{
  hoveredGame: MarbleGame | null
  onTrackClick: () => void
  currentGameId?: string
}>

export function TrackHighlight({ hoveredGame, onTrackClick, currentGameId }: Props) {
  const { topLayer, contentA, contentB } = useLayeredCrossfade<MarbleGame>(hoveredGame, 250)

  const renderCard = (game: MarbleGame | null) => {
    if (!game) return null

    return (
      <TrackHighlightCard
        game={game}
        isCurrent={game.id === currentGameId}
        onClick={() => {
          onTrackClick()
        }}
      />
    )
  }

  return (
    <div className="show-track-highlight-container">
      <div
        className={`highlight-layer layer-a ${topLayer === 'A' ? 'active' : ''}`}
        style={{
          opacity: topLayer === 'A' ? 1 : 0,
          transition: 'opacity 0.4s ease-in-out',
          zIndex: topLayer === 'A' ? 2 : 1
        }}
      >
        {renderCard(contentA)}
      </div>

      <div
        className={`highlight-layer layer-b ${topLayer === 'B' ? 'active' : ''}`}
        style={{
          opacity: topLayer === 'B' ? 1 : 0,
          transition: 'opacity 0.4s ease-in-out',
          zIndex: topLayer === 'B' ? 2 : 1
        }}
      >
        {renderCard(contentB)}
      </div>
    </div>
  )
}
